export const SET_LAYOUT_SETTINGS_DATA_LOADING = "SET_LAYOUT_SETTINGS_DATA_LOADING";
export const SET_LAYOUT_SETTINGS_DATA = "SET_LAYOUT_SETTINGS_DATA";
export const CLEAR_LAYOUT_SETTINGS_DATA = "CLEAR_LAYOUT_SETTINGS_DATA";